import { CardFields, CardProps, LinkField, StringField } from "../../types/types";

function getBaseImgSrc(index: string | number): string {
    return `//localhost:8085/images/Stories/Stories_${index}.jpg`;
}

export const mockCardList = [0, 1, 2, 3, 4, 5, 6, 7].map((index): {fields?: Partial<CardFields>} => {
    return {
        fields: {
            Image: {
                value: {
                    src: getBaseImgSrc(index),
                }
            }
        }
    }
}) as CardProps[];

export const mockTitle: StringField = { value: "Explore the world of " };

export const mockContent: StringField = {
    value: `
      From technological innovation to upcoming releases, from tutorials to brand communications.
      Discover our latest news and stay up to date!`,
  }

export const mockLink: LinkField = { value: { href:"", text:"OPTIONAL CTA" } }

export const mockEyebrow: StringField = { value: "OPTIONAL EYEBROW" }